<template>
    <h1>Weapons</h1>
</template>
<script>
export default {
    name: "Weapons"
};
</script>